import { createSlice, createAction } from "@reduxjs/toolkit";
import purge from "store/purge";

const initialState = {
  stripeCustomer: undefined,
  isLoading: false,
};

export default createSlice({
  name: "STRIPE_CUSTOMERS",
  initialState,
  reducers: {
    fetching: (state) => {
      state.isLoading = true;
    },

    error: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },

    success: (state) => {
      state.isLoading = false;
    },

    setStripeCustomer: (state, { payload }) => {
      state.stripeCustomer = payload;
    },
  },
  extraReducers: {
    ...purge(initialState),
  },
});
export const UPDATE_STRIPE_CUSTOMER_PAYMENT_METHOD = createAction(
  "UPDATE_STRIPE_CUSTOMER_PAYMENT_METHOD"
);
export const FETCH_STRIPE_CUSTOMER = createAction("FETCH_STRIPE_CUSTOMER");
export const FETCH_STRIPE_CUSTOMER_AS_ADMIN = createAction(
  "FETCH_STRIPE_CUSTOMER_AS_ADMIN"
);
export const UPDATE_STRIPE_CUSTOMER = createAction("UPDATE_STRIPE_CUSTOMER");
